'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Input, TimePickerNew } from 'dumb';
import { TableList, TableListRow, TableListCell } from 'dumb/tables/table-list';

// phrases
import phrases from './../../../globalBundleRules.phrases';

// lodash
import _get from 'lodash/get';

class GlobalBundleRulesBatchStepList extends Component {
	_onRemoveEntry(identifier) {
		const { removeBatchListItem } = this.props;

		removeBatchListItem(identifier);
	}

	_editListEntry(e, row, type) {
		// get value from event
		const value = e.target ? e.target.value || e.target.checked : e;

		// edits the row in the store
		this.props.editBatchListItem({
			...row,
			...{ [type]: value },
		});
	}

	render() {
		const { batchListData } = this.props;

		return (
			<TableList>
				<thead>
					<tr>
						<th>{phrases.MODAL_BATCH_STEP_LIST_TABLE_NUMBER}</th>
						<th>{phrases.MODAL_BATCH_STEP_WEEKDAY}</th>
						<th>{phrases.MODAL_BATCH_STEP_NAME}</th>
						<th>{phrases.MODAL_BATCH_STEP_DESCRIPTION}</th>
						<th>{phrases.MODAL_BATCH_FROM}</th>
						<th>{phrases.MODAL_BATCH_TO}</th>
						<th />
					</tr>
				</thead>
				<tbody>
					{batchListData.map((entry, i) => {
						return (
							<TableListRow key={entry.identifier}>
								<TableListCell>{i + 1}</TableListCell>
								<TableListCell>
									{_get(entry, 'weekday.label', '')}
								</TableListCell>

								<TableListCell>
									<Input
										id={`${entry.identifier}-name}`}
										placeholder={phrases.MODAL_BATCH_STEP_NAME_PLACEHOLDER}
										value={entry.name || ''}
										onChange={(event) =>
											this._editListEntry(event, entry, 'name')
										}
									/>
								</TableListCell>

								<TableListCell>
									<Input
										id={`${entry.identifier}-description`}
										placeholder={
											phrases.MODAL_BATCH_STEP_DESCRIPTION_PLACEHOLDER
										}
										value={entry.description || ''}
										onChange={(event) =>
											this._editListEntry(event, entry, 'description')
										}
									/>
								</TableListCell>

								<TableListCell>
									<TimePickerNew
										id="from"
										onChange={(event) =>
											this._editListEntry(event, entry, 'from')
										}
										value={entry.from}
									/>
								</TableListCell>

								<TableListCell>
									<TimePickerNew
										id="to"
										onChange={(event) =>
											this._editListEntry(event, entry, 'to')
										}
										value={entry.to}
									/>
								</TableListCell>

								<TableListCell>
									<Button
										id={`${entry.identifier}-delete`}
										type="negative"
										size="tiny"
										onClick={() => this._onRemoveEntry(entry.identifier)}>
										<span className="icon icon--delete" />
									</Button>
								</TableListCell>
							</TableListRow>
						);
					})}
				</tbody>
			</TableList>
		);
	}
}

GlobalBundleRulesBatchStepList.propTypes = {
	batchListData: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
};

export default GlobalBundleRulesBatchStepList;
